var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    style: {
      color: "rgb(74, 85, 101)"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.69 16.15h.62c1.48 0 2.67-1.23 2.67-2.75V6c0-1.52-1.2-2.75-2.67-2.75h-.62c-1.48 0-2.67 1.23-2.67 2.75v7.39c0 1.52 1.2 2.75 2.67 2.75ZM10.52 6c0-.69.53-1.25 1.17-1.25h.62c.65 0 1.17.56 1.17 1.25v7.39c0 .69-.53 1.25-1.17 1.25h-.62c-.65 0-1.17-.56-1.17-1.25zm7.23 3.39v4.23c0 2.81-2.22 5.09-5 5.23v1.9c0 .41-.34.75-.75.75s-.75-.34-.75-.75v-1.9c-2.78-.14-5-2.42-5-5.23V9.39c0-.41.34-.75.75-.75s.75.34.75.75v4.23a3.77 3.77 0 0 0 3.77 3.76h.97a3.77 3.77 0 0 0 3.77-3.76V9.39c0-.41.34-.75.75-.75s.75.34.75.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLive);
export default __webpack_public_path__ + "static/media/icon-live.494fd9fcee385979dd060c900d07d231.svg";
export { ForwardRef as ReactComponent };